import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Para quién es esto?',
  a: 'Dueños de negocio con operación activa que sienten que llegaron a un techo — ya sea por desorden interno o porque quieren llevar el negocio al siguiente nivel.'
}, {
  q: '¿Para quién NO es?',
  a: 'Personas empezando desde cero, o quienes buscan soluciones rápidas sin querer cambiar la estructura de fondo.'
}, {
  q: '¿Qué pasa en el diagnóstico?',
  a: 'Analizamos tu operación, identificamos los puntos críticos y te doy claridad estratégica sobre qué hacer primero.'
}, {
  q: '¿Es una llamada de ventas?',
  a: 'No. Es una conversación estratégica real — sin presión ni compromiso.'
}, {
  q: '¿Qué tipo de negocios aplican mejor?',
  a: 'Negocios con equipo, operación activa y voluntad de construir con criterio.'
}];
export function FAQSection() {
  return <section className="py-24 px-6 bg-navy" data-id="element-51">
      <div className="max-w-3xl mx-auto" data-id="element-52">
        <FadeIn data-id="element-53">
          <h2 className="text-3xl md:text-5xl font-serif text-center mb-16" data-id="element-54">
            Antes de agendar,{' '}
            <span className="text-gold" data-id="element-55">ten en cuenta esto</span>
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-56">
          {faqs.map((faq, i) => {
          const [isOpen, setIsOpen] = useState(i === 0);
          return <FadeIn key={i} delay={i * 0.1} data-id="element-57">
                <div className="border border-gold/30 rounded-lg overflow-hidden bg-white/[0.02]" data-id="element-58">
                  <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-59">
                    <span className="text-lg font-medium text-white" data-id="element-60">
                      {faq.q}
                    </span>
                    <ChevronDown className={`w-5 h-5 text-gold transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-61" />
                  </button>
                  <AnimatePresence data-id="element-62">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3
                }} data-id="element-63">
                        <div className="px-6 pb-5 text-gray-light" data-id="element-64">{faq.a}</div>
                      </motion.div>}
                  </AnimatePresence>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}